let language = {
    COUPON_CODE_LIMIT_QTY_TIP_1: "Only",
    COUPON_CODE_LIMIT_QTY_TIP_2: "coupon allowed per order",
};

export { language }